import Cookies from "js-cookie";

export type CookieAttributes = Cookies.CookieAttributes;

export type WMUCookiesAPI = {
  getString: (key: string, fallback?: string) => string;
  set: (key: string, value: string, options?: CookieAttributes) => string;
  remove: (key: string, options?: CookieAttributes) => void;
  has: (key: string) => boolean;
};

function normalizeValue(value: unknown, fallback: string): string {
  if (value === null || value === undefined) {
    return fallback;
  }
  return String(value);
}

const cookieFacade: WMUCookiesAPI = {
  getString(key: string, fallback = ""): string {
    return normalizeValue(Cookies.get(key), fallback);
  },
  set(key: string, value: string, options: CookieAttributes = {}): string {
    const normalized = String(value);
    Cookies.set(key, normalized, options);
    return normalized;
  },
  remove(key: string, options: CookieAttributes = {}): void {
    Cookies.remove(key, options);
  },
  has(key: string): boolean {
    return typeof Cookies.get(key) === "string";
  },
};

window.WMUCookies = cookieFacade;

export const cookieStore = cookieFacade;
